import CustomRolesModal from './CustomRolesModal';
import './CustomRolesModal.scss';

export default CustomRolesModal;
